module.exports = __webpack_public_path__ + "assets/4-account-executive-ae.c0719f94.png";